import React from 'react';
import T from 'prop-types';

/**
 * @param {{
 *   heading?: string;
 *   description?: string;
 *   list: Record<string, import('react').ReactNode>[];
 * }} props
 */
function DetailsInfoSection({ heading, description, list }) {
  return (
    <div className="bg-neutral-100 rounded-lg border border-neutral-300 p-5 mb-1.5 font-normal">
      {heading ? <h2 className="ui-text-h4 mb-8">{heading}</h2> : null}
      <h3 className="ui-text-h4 mb-3.5">{description}</h3>
      <ul className="ui-text-p3">
        {list.map((listItem) =>
          Object.entries(listItem).map(([key, value]) => {
            if (key === '') {
              return (
                <li key={value} className="mb-3.5">
                  <span className="font-normal ui-text-dark-grey">{value}</span>
                </li>
              );
            }

            return (
              <li key={key} className="flex justify-between mb-3.5">
                <span className="font-normal ui-text-dark-grey">{key}</span>
                <span className="font-normal text-charcoal-grey">{value}</span>
              </li>
            );
          }),
        )}
      </ul>
    </div>
  );
}

DetailsInfoSection.propTypes = {
  heading: T.string,
  description: T.string,
  list: T.array,
};

export { DetailsInfoSection };
